module.exports = __webpack_public_path__ + "img/armourfuse_w.758dd219.svg";